import { Container } from '@mui/material';
import React from 'react';
import { ScrollRestoration, useLoaderData } from 'react-router-dom';
import AppBar from '../app-bar/AppBar';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import MdViewer from '../markdown/MdViewer';

const ServiceLevelAgreement = () => {
  const serviceLevelAgreement = useLoaderData() as string;

  return (
    <>
      <AppBar title="Service Level Agreement" />
      <Breadcrumbs
        items={[{ label: 'Home', to: '/' }, { label: 'Profile', to: '/profile' }, { label: 'Service Level Agreement' }]}
        sx={{ display: { xs: 'none', sm: 'flex' } }}
      />
      <ScrollRestoration />
      <Container sx={{ my: 4 }}>
        <MdViewer text={serviceLevelAgreement}></MdViewer>
      </Container>
    </>
  );
};

export default ServiceLevelAgreement;
